import mutations from './utilityImport.mutations'
import actions from './utilityImport.actions'
import getters from './utilityImport.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}